import axios from 'axios';
import { stringify } from 'querystring';

import {
  API_URL,
  API_CONTEXT,
} from 'settings';
import { getCurrentSessionData } from 'utils/aws/cognito';
import { getSettings } from 'utils/settings';
import { toBase64Utf8 } from 'utils/strings';

const http = axios.create({
  baseURL: API_URL,
});

http.interceptors.request.use((config) => {
  const { accessToken } = getCurrentSessionData();
  config.headers.Authorization = accessToken;

  if (API_CONTEXT) {
    config.headers.context = getSettings('providers.dynamipay.apiContext');
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const {
      hash = '',
      pathname,
      search = '',
    } = window.location;

    if (error?.response?.status === 403 && !pathname.startsWith('/auth/')) {
      const query = {
        // `Buffer` no existe en el navegador (lanzaba ReferenceError). Mismo
        // esquema que AuthGuard para que SignIn lo decodifique y valide.
        redirect: toBase64Utf8(`${pathname}${search}${hash}`),
      };

      window.location = `/auth/login?${stringify(query)}`;

      // La página se está descargando: no se resuelve para que nadie procese
      // una respuesta inexistente.
      return new Promise(() => { });
    }

    // Antes un 403 dentro de /auth/ resolvía con undefined y el consumidor
    // reventaba al leer la respuesta, reportándolo como error de configuración.
    return Promise.reject(error);
  },
);

export default http;
